const ITEMS = [
  "Authentic Butter Chicken",
  "Clay Tandoor Fire",
  "Fresh Garlic Naan",
  "Designer Curries",
  "Slow-Cooked Dum Biryani",
  "Fresh-Ground Spices",
  "Chapel Hill's Own",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="relative overflow-hidden border-y border-[#C97B5F]/15 bg-[#F9F3EA] py-6 sm:py-7"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-6 font-display text-xl italic text-[#3A2C1E]/50 sm:px-8 sm:text-2xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#E86A24]/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
